import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import FormLayout from "components/form/FormLayout";
import React from "react";
import { useTranslation } from "react-i18next";
import TextEditor from "components/textEditor/textEditor";
import "./facilitySettings.scss";

interface IProps {
  state: Partial<IPutTeeSheetSettings>;
  updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function FacilityInvoiceSettings(props: IProps) {
  const { state, updateState } = props;
  const { t } = useTranslation();

  return (
    <div className="facility-settings-section p-2">
      <FormLayout>
        <FormLayout.Group>
          <TextEditor
            label={t("Invoice terms")}
            markdownTextOnChange={value => updateState("invoice_terms", value)}
            markdownText={state?.invoice_terms}
          />
        </FormLayout.Group>
      </FormLayout>
      <p className="facility-settings-help-text">
        {t("Shows the terms to the customer on invoices to review before paying.")}
      </p>
    </div>
  );
}
